@if(input_position() == 'start'){
    <hr class="linestart" />
} @else {
    <hr class="lineend" />
}
